import React, { Component } from "react"
import { Button, Menu, Select, Input, Icon, DatePicker, Pagination, Affix, Row } from "antd"
import ReportCard from "app/components/normal/pgd/ReportCard"
import reportIcon from "app/styles/images/sp/report-selected.svg"
import "./Index.scss"
import moment from "moment"
import { observer } from "mobx-react"
import BatchShareModal from "./BatchShareModal"
import Store from "app/stores/pgd/report"
import queryString from "query-string"

const { Search } = Input
const RangePicker = DatePicker.RangePicker

@observer
export default class Index extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      dataList: [],
      list: ["all"],
      dateValue: null,
      batchShareOpened: false,
      searchType: 'keywords',
    }
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps

    if (nextLocation.search !== location.search) {
      const searchObj = queryString.parse(nextLocation.search)
      this.setState({
        inputSearch: searchObj.keywords
      })
      if (nextLocation.search) {
        this.loadLimitedData(searchObj)
      } else {
        this.loadAllData()
      }
    }
  }

  onDataChange = (e, type) => {
    switch (type) {
      case "belong": this.onBelongChange(e)
        break
      case "app": this.onAppChange(e)
        break
      case "day": this.onDayChange(e)
        break
      default: this.dateChangeOk()
    }
  }

  onBelongChange = (e) => {
    this.setState({
      belong: e.key,
    })
    let { list: { filterData } } = this.store

    filterData({ belong: e.key })
  }

  onAppChange = (e) => {
    this.setState({
      app: e.key,
    })
    let { list, list: { queryMap } } = this.store
    let appQueryValue = null
    let isHistory = ""
    if (e.key === 0 || e.key === "0") {
      appQueryValue = null
      isHistory = "查看历史数据"
    } else if (e.key === "app_id_999" && queryMap.app === "999") {
      isHistory = "查看历史数据"
      appQueryValue = null
    } else if (e.key === "app_id_999" && (queryMap.app !== "999" || queryMap.app === null)) {
      isHistory = "关闭历史数据"
      appQueryValue = "999"
    } else {
      let appIdString = (e.key).replace("app_id_", "")
      appQueryValue = appIdString
      isHistory = "查看历史数据"
    }
    this.setState({
      isHistory
    })
    list.filterData({ app: appQueryValue })
  }

  changeSearch = (e) => {
    const keywords = e.target.value
    this.setState({
      inputSearch: keywords
    })
  }

  searchData = () => {
    const { match, history } = this.props
    const { searchType } = this.state
    history.push({
      pathname: `${match.url}/search`,
      search: queryString.stringify({
        [`${searchType}`]: this.state.inputSearch,
        app: this.state.appQueryValue
      })
    })
  }

  dateChange = (dateValue, dateString) => {
    const { list: { updateQueryMap } } = this.store
    updateQueryMap({ start: dateString[0], end: dateString[1] })
    this.setState({     //日期回显
      dateValue: dateValue
    })
  }

  dateChangeOk = () => {
    this.setState({  // 重置近几天的选项
      dayKey: "-1",
    })
    let {
      list: { filterData, queryMap }
    } = this.store

    filterData({ end: moment(queryMap.end, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD") })
  }

  onDayChange = (e) => {
    let startDay = null
    const {
      list: { filterData }
    } = this.store

    this.setState({  //设置近几天同时重置日期选择
      dayKey: e.key,
      dateValue: null,
    })
    if (e.key !== "-1") {
      startDay = moment(moment() - e.key * 1000 * 3600 * 24).format("YYYY-MM-DD")
    }

    filterData({ start: startDay, end: null })
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  searchTypeChange = (e) => {
    const { list: { queryMap } } = this.store
    this.setState({
      searchType: e,
      inputSearch: ''
    })
    queryMap[this.state.searchType] = ''
    this.refs.pgdSearchInput.input.focus()
  }

  componentDidMount() {
    let { list } = this.store
    let { location } = this.props

    list.getApps('common', { filter: 'used' })
    if (location.search) {
      const searchObj = queryString.parse(location.search)
      this.setState({
        inputSearch: searchObj.keywords
      })
      this.loadLimitedData(searchObj)
    } else {
      this.loadAllData()
    }
  }

  loadLimitedData(queryObj) {
    this.store.list.filterData(queryObj)
  }

  loadAllData() {
    const { list } = this.store
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
          this.setState({
            app: "0",
            belong: "all",
            dayKey: "-1"
          })
        }
      )
  }

  onShowSizeChange = (current, pageSize) => {
    let { getTableData, updateTableData, initPageIndexAndOffset, updateQueryMap, queryMap } = this.store
    updateQueryMap({ limit: pageSize })
    initPageIndexAndOffset()
    getTableData(queryMap)
      .then(
        res => {
          updateTableData(res)
        }
      )
  }

  onPaginChange = selectedPageNumber => {
    let {
      list
    } = this.store

    list.changePagin(selectedPageNumber)
    document.getElementById("contentTop").scrollIntoView(true)
  }

  disabledDate = (current) => {
    return current && current.valueOf() > Date.now()
  }

  closeModal = (modal, cb) => {
    this.setState({
      [modal]: false
    })
    if (typeof cb === "function") {
      cb()
    }
  }

  render() {
    const { store: { list: { tableData, totalCount, currentPageIndex, queryMap } }, store } = this
    return (
      <div className="pgd report-page">
        <h2 className="page-title"><img alt="" src={reportIcon} />报告列表</h2>
        {this.renderHeader()}
        <div className="report-card-wrap">
          {tableData.map((data, index) =>
            <ReportCard store={store} key={data.groupId + "_groupId" + index} data={data} index={index} />
          )}
        </div>
        <div className="pagin-bottom">
          <Pagination
            showSizeChanger
            pageSize={queryMap.limit}
            onShowSizeChange={this.onShowSizeChange}
            onChange={this.onPaginChange}
            defaultCurrent={1}
            current={currentPageIndex}
            total={totalCount} />
        </div>
        {
          this.state.batchShareOpened && (
            <BatchShareModal
              onClose={() => this.closeModal("batchShareOpened")}
              store={this.store}
              tableData={tableData}
            />
          )
        }
      </div>
    )
  }

  renderHeader = () => {
    const { inputSearch } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}>
        <div className="affix-back">
          <div className="first-line">
            {this.renderUserMenu()}
            {this.renderDayMenu()}
          </div>
          <div className="report-search-bar">
            <Row type="flex" justify="space-between" align="middle" className="content">
              <Row type="flex" align="middle">
                <div className="search-input">
                  <Select
                    defaultValue="keywords"
                    onChange={this.searchTypeChange}
                  >
                    <Select.Option value="keywords">按关键字</Select.Option>
                    <Select.Option value="organization">按送检单位</Select.Option>
                  </Select>
                  <Search
                    value={inputSearch}
                    placeholder="请输入关键字搜索"
                    size="default"
                    ref="pgdSearchInput"
                    onChange={this.changeSearch}
                    onSearch={this.searchData}
                  />
                </div>
              </Row>
              <Row>
                <Button
                  style={{ marginRight: 14 }}
                  type="primary"
                  onClick={() => this.showModal("batchShareOpened")}
                >
                  批量共享
                </Button>
              </Row>
            </Row>
          </div>
        </div>
      </Affix>
    )
  }

  renderUserMenu = () => {
    return (
      <div className="user-menu">
        <Menu
          className="menu-all" onClick={e => this.onDataChange(e, "belong")}
          key="menu_share_0"
          selectedKeys={[this.state.belong]}
          mode="horizontal">
          <Menu.Item key="all">
            <Icon type="cloud-o" />全部
          </Menu.Item>
          <Menu.Item key="self">
            <Icon type="team" />自己的
          </Menu.Item>
          <Menu.Item key="share">
            <Icon type="share-alt" />分享而来
          </Menu.Item>
        </Menu>
      </div>
    )
  }

  renderDayMenu = () => {
    return (
      <div className="report-search-time-bar">
        <Menu className="menu-day" onClick={e => this.onDataChange(e, "day")}
          selectedKeys={[this.state.dayKey]}
          mode="horizontal"
          key="menu_date_0">
          <Menu.Item key="-1">
            <Icon type="calendar" />全部
          </Menu.Item>
          <Menu.Item key="0">今天</Menu.Item>
          <Menu.Item key="3">三天内</Menu.Item>
          <Menu.Item key="7">七天内</Menu.Item>
          <Menu.Item key="15">十五天内</Menu.Item>
          <Menu.Item key="30">三十天内</Menu.Item>
        </Menu>
        <RangePicker
          ranges={{
            "今天": [moment(), moment()],
            "本月": [moment().startOf("month"), moment()]
          }}
          showTime
          value={this.state.dateValue}
          onChange={this.dateChange}
          onOk={this.onDataChange}
          disabledDate={this.disabledDate}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgd/report/index.js